import React from "react";

export default function ServiceAreaIcon(props?: any) {

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});

  return (        
    <svg 
      viewBox="0 0 200 200"
      style={{...filteredStyles, fill : "none"}}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22_2)">
        <path d="M100 0C80.2219 0 60.8879 5.8649 44.443 16.853C27.9981 27.8412 15.1809 43.459 7.61209 61.7317C0.0433273 80.0042 -1.937 100.111 1.92151 119.509C5.78003 138.907 15.3041 156.726 29.2893 170.711C43.2746 184.696 61.0929 194.22 80.491 198.079C99.8891 201.937 119.996 199.957 138.269 192.388C156.541 184.819 172.159 172.002 183.147 155.557C194.136 139.112 200 119.778 200 100C200 73.4783 189.464 48.043 170.711 29.2893C151.957 10.5357 126.522 0 100 0ZM100 186.688C82.8549 186.688 66.0948 181.603 51.839 172.078C37.5833 162.552 26.4724 149.014 19.9112 133.173C13.3501 117.333 11.6333 99.9038 14.9782 83.0881C18.3231 66.2723 26.5792 50.8261 38.7027 38.7027C50.8262 26.5792 66.2724 18.323 83.0881 14.9782C99.9039 11.6333 117.333 13.35 133.174 19.9112C149.014 26.4723 162.552 37.5833 172.078 51.839C181.603 66.0947 186.688 82.8548 186.688 100C186.671 122.986 177.532 145.026 161.279 161.279C145.026 177.532 122.986 186.671 100 186.688Z" fill={filteredStyles.fill || "#3B4559"}/>
        <path d="M110.875 56.6873C109.646 54.9462 108.016 53.5258 106.124 52.5453C104.232 51.5649 102.131 51.0532 100 51.0532C97.8687 51.0532 95.7686 51.5649 93.8761 52.5453C91.9837 53.5258 90.3543 54.9462 89.125 56.6873L66.6876 88.4373C64.3015 91.8208 63.0206 95.8597 63.0206 99.9999C63.0206 104.14 64.3015 108.179 66.6876 111.562L89.125 143.312C90.3543 145.053 91.9837 146.473 93.8761 147.454C95.7686 148.434 97.8687 148.947 100 148.947C102.131 148.947 104.232 148.434 106.124 147.454C108.016 146.473 109.646 145.053 110.875 143.312L133.312 111.562C135.699 108.179 136.98 104.14 136.98 99.9999C136.98 95.8597 135.699 91.8208 133.312 88.4373L110.875 56.6873ZM100 64.4373L120.438 93.3749H79.5626L100 64.4373ZM100 135.624L79.5626 106.687H120.5L100 135.624Z" fill={filteredStyles.fill || "#3B4559"}/>
      </g>
      <defs>
        <clipPath id="clip0_22_2">
          <rect width="200" height="200" fill={filteredStyles.fill || "#3B4559"} />
        </clipPath>
      </defs>
    </svg>    
  )
}